export const SET_LOADING = 'SET_LOADING';
export const SET_FILE_LIST = 'SET_FILE_LIST';
export const SET_USER_INFO = 'SET_USER_INFO';
// alert
export const SET_ALERT = 'SET_ALERT';
